import React from 'react';
import Draggable from 'react-draggable';
import { Paper } from '@mui/material';

export const PaperComponent = (props) => {
  const { sx, ...other } = props;
  return (
    <Draggable handle='#draggable-dialog-title' cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper
        {...other}
        sx={[{ borderRadius: '10px' }, ...(Array.isArray(sx) ? sx : [sx])]}
        onClick={(e) => {
          e.stopPropagation();
        }}
      />
    </Draggable>
  );
};
